// extracted by mini-css-extract-plugin
export default {"descriptionLabel":"ProfileInformation_descriptionLabel__v235S","errorMessage":"ProfileInformation_errorMessage__kSoIX"};